import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import HeaderComponent from './components/HeaderComponent';
import AboutComponent from './components/AboutComponent';
import SolutionsComponent from './components/SolutionsComponent';
import JobsComponent from './components/JobsComponent';
import ContactComponent from './components/ContactComponent';
import FooterComponent from './components/FooterComponent';
import TermsComponent from './components/TermsComponent'

import initialAppLoad from './utils/initialLoader';

import { useEffect, useState, useCallback } from 'react';
import { loadHeaderLabelsEn, loadHeaderLabelsRo } from './constants/HeaderConstants';
import { loadAboutContentEn, loadAboutContentRo } from './constants/AboutConstants';
import { loadSolutionsContentEn, loadSolutionsContentRo } from './constants/SolutionsConstants';
import { loadJobsContentEn, loadJobsContentRo } from './constants/JobsConstants';
import { loadContactContentEn, loadContactContentRo } from './constants/ContactConstants';
import { loadEmailFormConstantsEn, loadEmailFormConstantsRo } from './constants/EmailFormConstants';
import { loadFooterConstantsEn, loadFooterConstantsRo } from './constants/FooterConstants';
import { loadTermsContentEn, loadTermsContentRo } from './constants/TermsConstants';

import ScrollToTop from './utils/ScrollToTop';

//import TermsComponent2 from './components/TermsComponent2'

const MainWrapper = ({ tabLabels, currentLanguage, handleLanguageChange, aboutContent, solutionsContent, jobsContent, contactContent, emailLabels, footerContent }) => {
    return (
        <div>
            <div className="background"></div>
            <div className="App">
                <HeaderComponent tabLabels={tabLabels} currentLanguage={currentLanguage}
                                 onLanguageChange={handleLanguageChange}/>
                <section id="about-section">
                    <AboutComponent aboutContent={aboutContent}/>
                </section>
                <section id="solutions-section">
                    <SolutionsComponent solutionsContent={solutionsContent}/>
                </section>
                <section id="jobs-section">
                    <JobsComponent jobsContent={jobsContent}/>
                </section>
                <section id="contact-section">
                    <ContactComponent contactContent={contactContent} emailLabels={emailLabels}/>
                    <FooterComponent footerContent={footerContent}/>
                </section>
            </div>
        </div>
    )
}

const TermsWrapper = ( {termsContent, lang} ) => {
    return (
        <div>
            <div className="background"></div>
            <div className="App">
                <TermsComponent termsContent={termsContent} lang={lang}/>
            </div>
        </div>
    )
}

function App() {
    const [isContentLoaded, setIsContentLoaded] = useState(false);
    const [tabLabels, setTabLabels] = useState(null);
    const [aboutContent, setAboutContent] = useState(null);
    const [solutionsContent, setSolutionsContent] = useState(null);
    const [jobsContent, setJobsContent] = useState(null);
    const [contactContent, setContactContent] = useState(null);
    const [footerContent, setFooterContent] = useState(null);
    const [termsContent, setTermsContent] = useState(null);
    const [emailLabels, setEmailLabels] = useState(null);
    const [currentLanguage, setCurrentLanguage] = useState('en');

    const handleLanguageChange = useCallback((lang) => {
        setIsContentLoaded(false);
        setCurrentLanguage(lang);
    }, []);

    useEffect(() => {
        const loadAppContent = async () => {
            await initialAppLoad();

            const loadLabels = currentLanguage === 'en' ? loadHeaderLabelsEn : loadHeaderLabelsRo;
            const loadAbout = currentLanguage === 'en' ? loadAboutContentEn : loadAboutContentRo;
            const loadSolutions = currentLanguage === 'en' ? loadSolutionsContentEn : loadSolutionsContentRo;
            const loadJobs = currentLanguage === 'en' ? loadJobsContentEn : loadJobsContentRo;
            const loadContact = currentLanguage === 'en' ? loadContactContentEn : loadContactContentRo;
            const loadEmailLabels = currentLanguage === 'en' ? loadEmailFormConstantsEn : loadEmailFormConstantsRo;
            const loadFooter = currentLanguage === 'en' ? loadFooterConstantsEn : loadFooterConstantsRo;
            const loadTerms = currentLanguage === 'en' ? loadTermsContentEn : loadTermsContentRo;

            const labels = loadLabels();
            const aboutContent = loadAbout();
            const solutionsContent = loadSolutions();
            const jobsContent = loadJobs();
            const contactContent = loadContact();
            const emailFormLabels = loadEmailLabels();
            const footerContent = loadFooter();
            const termsContent = loadTerms();

            setTabLabels(labels);
            setAboutContent(aboutContent);
            setSolutionsContent(solutionsContent);
            setJobsContent(jobsContent);
            setContactContent(contactContent);
            setEmailLabels(emailFormLabels);
            setFooterContent(footerContent);
            setTermsContent(termsContent);

            setIsContentLoaded(true);
        };

        loadAppContent();
    }, [currentLanguage]);

    if (!isContentLoaded || tabLabels === null || aboutContent === null || solutionsContent === null || jobsContent === null || contactContent === null || emailLabels === null) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#1a1a1a',
                color: '#7859FF',
            }}>
                <div
                    className="spinner"
                    style={{
                        border: '8px solid #333',
                        borderTop: '8px solid #7859FF',
                        borderRadius: '50%',
                        width: '60px',
                        height: '60px',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '20px'
                    }}
                ></div>

                <style>
                    {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    `}
                </style>
                <div style={{ fontSize: '1.2rem' }}></div>
            </div>
        );
    } else {
        return (
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<MainWrapper
                        tabLabels={tabLabels}
                        currentLanguage={currentLanguage}
                        handleLanguageChange={handleLanguageChange}
                        aboutContent={aboutContent}
                        solutionsContent={solutionsContent}
                        jobsContent={jobsContent}
                        contactContent={contactContent}
                        emailLabels={emailLabels}
                        footerContent={footerContent}
                    />} />

                    <Route path="/termeni-conditii" element={<TermsWrapper termsContent={termsContent} lang={currentLanguage}/>} />
                </Routes>
            </BrowserRouter>
            // <TermsComponent2/>
        );
    }
}

export default App;
